import { buildMockCloudConnectivity } from '@mocks/data/cloudConnectivity';
import type { MockContext } from '@mocks/mockFetch';

type MockHandler = (ctx: MockContext) => Promise<Response | null> | Response | null;

const matchesCloudConnectivityResolve = (url: URL): boolean => {
  const parts = url.pathname.split('/').filter(Boolean);
  const orgsIndex = parts.indexOf('orgs');
  return orgsIndex >= 0 && parts.slice(orgsIndex + 2).join('/') === 'topology/views/aws_cloud_overview/resolve';
};

const resolveCloudConnectivity: MockHandler = async ({ request, url }) => {
  if (request.method !== 'POST' || !matchesCloudConnectivityResolve(url)) return null;
  const body = await request.clone().json().catch(() => ({})) as { scopeType?: unknown; scopeId?: unknown };
  const scopeType = typeof body.scopeType === 'string' && body.scopeType ? body.scopeType : 'site';
  const scopeId = typeof body.scopeId === 'string' && body.scopeId ? body.scopeId : 'site-aws';
  return new Response(JSON.stringify(buildMockCloudConnectivity(scopeType, scopeId)), {
    status: 200,
    headers: { 'Content-Type': 'application/json', 'X-Mock-Route': 'cloud-connectivity' }
  });
};

export const cloudConnectivityHandlers: MockHandler[] = [resolveCloudConnectivity];
